import { markRaw, type Component } from 'vue'
import { useModal, type ModalOpenOptions } from '@dacr/library'

export enum Modals {
  DeleteFolders,
  CannotDeleteFolder,
  ConfirmMove,
  Success,
  Error,
  Download,
  ProcessingDownload,
  ArchiveFiles,
  ConfirmArchiveFiles,
  MakeFilesPrivate,
  MakeFilesPublic,
  RemoveFileAccess,
  RemoveFileOwner,
  RemoveFileAuthor,
  UploadProfilePicture,
  ConfirmProfilePicture,
  DeleteCopyrightOwner,
  ConfirmAccountClosure,
  AccountClosed,
  ConfirmCancelPlan,
  Resubscribe,
  Pay,
  AddPaymentMethod,
  WelcomeToDacrPro,
  WelcomeToDacrMembership,
  UploadTip,
  Notice,
  RemoveInfringingFile,
  LeaveReportCreation,
  ConfirmReportCreation,
  PurchaseCreditsSuccess,
  ConfirmUpload,
  UploadPrivacy,
  ConfirmUploadDetails,
  UploadJurisdictions,
  CancelUpload,
  UpgradeToPro,
  UpgradeBundleLimit,
  Maintenance,
}

const registry = new Map<Modals, Component>()

export const registerModal = (name: Modals, component: Component) => {
  registry.set(name, markRaw(component))
}

export const openModal = (name: Modals, opts?: ModalOpenOptions) => {
  const component = registry.get(name)
  if (!component) return
  return useModal().open(component, { ...opts, name: Modals[name] })
}

export const closeModal = (data?: unknown) => useModal().close(data)
export const closeAllModals = () => useModal().closeAll()
